module.exports = __webpack_public_path__ + "static/media/color-fast.7532d0b8.svg";